const ReturnIdIfExists = (array, id) => {
  const results = array.filter(arr => arr?.id?.toString() === id?.toString())
  return results[0]
}

export default ReturnIdIfExists
